<template>
  <button
    type="button"
    class="lcu-button-cta"
    :class="[classes, {
      'lcu-botton-secondary': type === 'secondary',
      'lcu-button-light': type === 'light',
      'lcu-button-primaryLight': type === 'primary-light',
      'lcu-button-border': border,
      'lcu-button-onLoad': loading,
      'lcu-button-disabled': disabled,
    }]"
    @click.prevent.stop="onClick"
    :disabled="disabled"
    :name="name">
    <span v-if="!loading && !html && text">{{ text }}</span>
    <span v-if="!loading && html" v-html="html"></span>
    <span v-if="loading" class="lcu-button-loading"></span>
  </button>
</template>

<script>
export default {
  name: 'button-cta',
  props: {
    name: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
      default: 'Button Text',
    },
    html: {
      type: String,
      required: false,
      default: '',
    },
    border: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    classes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    onClick() {
      this.$emit('on-click');
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-button-cta {
  background-color: $legacy-primary;
  border: 0;
  border-radius: 3px;
  color: $white;
  font-weight: 600;
  padding: 10px 25px;
  text-align: center;
  transition-duration: .1s;

  &:hover {
    cursor: pointer;
    transform: translateY(-1px);
  }
}

.lcu-button-border {
  background-color: transparent;
  border: 2px solid $legacy-primary;
  color: $legacy-primary;

  &:hover {
    background-color: $legacy-primary;
    color: $white;
  }
}

.lcu-botton-secondary {
  background-color: $legacy-secondary;

  &.lcu-button-border {
    background-color: transparent;
    border: 2px solid $legacy-secondary;
    color: $legacy-secondary;

    &:hover {
      background-color: $legacy-secondary;
      color: $white;
    }
  }
}

.lcu-button-light {
  border: 0;
  color: $gray-dark;
  background-color: $off-white;

  &:hover {
    cursor: pointer;
    transform: translateY(-1px);
  }
}

.lcu-button-primaryLight {
  border: 0;
  color: $white;
  background-color: $legacy-primary-light;

  &:hover {
    cursor: pointer;
    transform: translateY(-1px);
  }
}

.lcu-button-loading {
  animation: rotation 1s linear infinite;
  display: inline-block;

  &:before {
    content: '\e816';
    font-family: 'lcu';
    // font-size: 21px;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.lcu-button-onLoad {

  // in case any added class icons exist
  &:after {
    content: '' !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: none !important;
  }

  &:before {
    content: '' !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: none !important;
  }
}

.lcu-button-delete {
  background-color: $danger;
  border: 0;
  color: $white;
  margin-left: 5px;
  padding: 10px;
  transition-duration: .1s;

  &:hover {
    background-color: #ee4545;
    cursor: pointer;
    transform: translateY(-1px);
  }
}

.lcu-button-disabled {
  opacity: 0.5;

  &:hover {
    cursor: not-allowed;
  }
}

.lcu-wideBtn {
  width: 100%;
}

.lcu-mobile-wideBtn {
  @media only screen and (max-width: $mobile-max) {
    width: 100%;
  }
}

.lcu-span-weight {
  span {
    font-weight: normal;
  }
}
</style>
